import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link as MuiLink,
  IconButton,
  Divider,
} from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, rgb(0,40,15), rgb(0,60,25))',
        color: 'rgba(230,255,230,0.9)',
        pt: 8,
        pb: 4,
        mt: -6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} justifyContent="space-between">
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              fontWeight={700}
              gutterBottom
              sx={{ fontFamily: 'Playfair Display, serif', color: '#a5d6a7' }}
            >
              About MazGuard
            </Typography>
            <Typography
              variant="body2"
              sx={{ lineHeight: 1.7, maxWidth: 300, color: 'rgba(255,255,255,0.8)' }}
            >
              MazGuard is a community-powered platform for reporting and
              tracking environmental issues across Kenya. Together, we can
              protect our planet 🌿.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              fontWeight={700}
              gutterBottom
              sx={{ fontFamily: 'Playfair Display, serif', color: '#a5d6a7' }}
            >
              Quick Links
            </Typography>
            <Box>
              {[
                { label: 'Home', href: '/' },
                { label: 'Track Issues', href: '/issues' },
                // { label: 'Events', href: '/events' },
                { label: 'Reviews', href: '/reviews' },
                { label: 'Terms & Conditions', href: '/terms' },
                { label: 'Privacy Policy', href: '/privacy' },
              ].map((link, index) => (
                <MuiLink
                  key={index}
                  href={link.href}
                  color="inherit"
                  underline="hover"
                  display="block"
                  sx={{
                    py: 0.5,
                    fontSize: '0.95rem',
                    color: 'rgba(255,255,255,0.85)',
                    '&:hover': { color: '#81c784' },
                  }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Box>
          </Grid>

          {/* Socials */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              fontWeight={700}
              gutterBottom
              sx={{ fontFamily: 'Playfair Display, serif', color: '#a5d6a7' }}
            >
              Connect With Us
            </Typography>
            <Box display="flex" gap={1.5} mt={1}>
              <IconButton href="#" sx={{ color: '#a5d6a7', '&:hover': { color: '#81c784' } }}>
                <Facebook />
              </IconButton>
              <IconButton href="#" sx={{ color: '#a5d6a7', '&:hover': { color: '#81c784' } }}>
                <Twitter />
              </IconButton>
              <IconButton href="#" sx={{ color: '#a5d6a7', '&:hover': { color: '#81c784' } }}>
                <Instagram />
              </IconButton>
              <IconButton href="#" sx={{ color: '#a5d6a7', '&:hover': { color: '#81c784' } }}>
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.15)' }} />

        {/* Bottom Note */}
        <Box textAlign="center">
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: '0.9rem',
            }}
          >
            &copy; {new Date().getFullYear()} MazGuard. All rights reserved.  
            
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
